import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { FileType, FileValidation, TaskDataType } from "types/DataTypes";

interface FileState {
  currentFile: FileType | null;
  fileValidation: FileValidation | null;
  fileId: number | null;
  selectedFileIds: (string | number)[];
  showArchiveModal: boolean;
  showMergeModal: boolean;
  currentTask: TaskDataType | null;
}

const initialState: FileState = {
  currentFile: null,
  fileValidation: null,
  fileId: null,
  selectedFileIds: [],
  showArchiveModal: false,
  showMergeModal: false,
  currentTask: null,
};

const fileSlice = createSlice({
  name: "file",
  initialState,
  reducers: {
    setCurrentFile: (state, action: PayloadAction<FileType>) => {
      state.currentFile = action.payload;
    },
    setFileValidation: (state, action: PayloadAction<FileValidation>) => {
      state.fileValidation = action.payload;
    },
    setFileId: (state, action: PayloadAction<number>) => {
      state.fileId = action.payload;
    },
    setSelectedFileIds: (state, action: { payload: (string | number)[] }) => {
      state.selectedFileIds = action.payload;
    },
    setShowArchiveModal: (state, action: PayloadAction<boolean>) => {
      state.showArchiveModal = action.payload;
    },
    setShowMergeModal: (state, action: PayloadAction<boolean>) => {
      state.showMergeModal = action.payload;
    },
    setCurrentTask: (state, action: PayloadAction<TaskDataType>) => {
      state.currentTask = { ...state.currentTask, ...action.payload };
    },
    clearCurrentTask: (state) => {
      state.currentTask = null;
    },
  },
});

export const {
  setShowArchiveModal,
  setShowMergeModal,
  setCurrentFile,
  setFileValidation,
  setFileId,
  setSelectedFileIds,
  setCurrentTask,
  clearCurrentTask,
} = fileSlice.actions;
export default fileSlice.reducer;
